import { render } from "./LogoComponent.vue?vue&type=template&id=361afa1a&scoped=true"
import script from "./LogoComponent.vue?vue&type=script&lang=js"
export * from "./LogoComponent.vue?vue&type=script&lang=js"

import "./LogoComponent.vue?vue&type=style&index=0&id=361afa1a&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361afa1a"]])

export default __exports__